export default __webpack_public_path__ + "static/media/img_3.3bbdf6f4.jpg";